import React, { useState } from 'react';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Form, List, Popover, Row, Tag } from 'antd';
import { isNil } from 'lodash';
import moment from 'moment';
import Link from 'next/link';
import { TagsGroupList } from '@gtintel/platform-atoms';
import { DEFAULT_DATE_PICKER_TIME_FORMAT, DEFAULT_TIME_FORMAT, TAG_COLORS } from '@gtintel/platform-constants';
import { ClientState, PartnerState, ProjectSteps } from '@gtintel/platform-molecules';
import { AccountingModal, AdjustmentModal } from '@gtintel/platform-organisms';
import { formatTagList } from '../../projectUtils';
import ActionButtons from '../ActionButtons';
import EditProjectDetailsModal from '../EditProjectDetailsModal';
import ProjectDescriptionPanel from '../ProjectDescriptionPanel';
import PricingDetail from './PricingDetail';
import * as S from './styles';
function formatDate(date) {
  return moment(date, DEFAULT_DATE_PICKER_TIME_FORMAT).isValid() ? moment(date, DEFAULT_DATE_PICKER_TIME_FORMAT) : moment(date);
}
const ProjectDetailContent = ({
  changeProjectStatus,
  changeStatusToActivated,
  confirm,
  projectDetail,
  sendMessengerTo,
  createSubProject,
  subprojects,
  tagCategoryList
}) => {
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isAccountingModalVisible, setIsAccountingModalVisible] = useState(false);
  const [isAdjustmentModalVisible, setIsAdjustmentModalVisible] = useState(false);
  const requestedCompletionDate = formatDate(projectDetail?.requested_completion_date);
  const requestedAnonymityType = projectDetail?.request_anonymity ? 'danger' : null;
  const qaRequiredType = projectDetail?.qa_required ? 'info' : null;
  return <S.LeftPanel>
      <S.ProjectTitle>{projectDetail.name}</S.ProjectTitle>
      <S.DetailSection>
        <S.DetailInfo>
          <p>
            Project ID:{' '}
            <S.DetailValue data-testid="project-id-span">
              {projectDetail.id ?? '-'}
            </S.DetailValue>
          </p>
          {!isNil(projectDetail.parent_id) && <p>
              Parent:{' '}
              <S.DetailValue data-testid="project-id-span">
                <Link as={`/admin/project/detail/${projectDetail.parent_id}`} href="/admin/project/detail/[id]">
                  {projectDetail.parent_name}
                </Link>
              </S.DetailValue>
            </p>}
          {subprojects.length > 0 && <p>
              Subprojects:
              <br />
              {subprojects.map(project => <S.DetailValueDiv data-testid="project-id-span">
                  <Link as={`/admin/project/detail/${project.id}`} href="/admin/project/detail/[id]">
                    {project.name}
                  </Link>
                </S.DetailValueDiv>)}
            </p>}
        </S.DetailInfo>
        <S.DetailInfo>
          <S.DetailKey>
            Created date:{' '}
            <S.DetailValue>
              {projectDetail.created_date ? formatDate(projectDetail.created_date).format(DEFAULT_TIME_FORMAT) : '?'}
            </S.DetailValue>
          </S.DetailKey>
          <S.DetailKey type={requestedAnonymityType}>
            Requested Anonymity:{' '}
            <S.DetailValue type={requestedAnonymityType} data-testid="requested-anonymity-span">
              {projectDetail.request_anonymity ? 'Yes' : 'No'}
            </S.DetailValue>
          </S.DetailKey>

          <S.DetailKey type={qaRequiredType}>
            QA Required:{' '}
            <S.DetailValue type={qaRequiredType} data-testid="qa-required-span">
              {projectDetail.qa_required ? 'Yes' : 'No'}
            </S.DetailValue>
          </S.DetailKey>

          {!projectDetail.qa_required ? null : <p>
              Due Date:{' '}
              <S.DetailValue data-testid="qa-due-date-span">
                {projectDetail.np_completion_date ? moment(projectDetail.np_completion_date).format(DEFAULT_TIME_FORMAT) : '?'}
              </S.DetailValue>
            </p>}
        </S.DetailInfo>
      </S.DetailSection>
      <S.DescriptionSection>
        <S.DescriptionTitle>Brief Description</S.DescriptionTitle>
        <div>
          <ProjectDescriptionPanel isAdmin={true} project={projectDetail} />
          {projectDetail?.additional_info?.length > 0 && <S.WrapContent>
              <b>Additional Info:</b> {projectDetail?.additional_info}
            </S.WrapContent>}
        </div>
      </S.DescriptionSection>
      <S.TagAndActionBtn>
        <div>
          <S.LabelSpan>Tags&ensp;</S.LabelSpan>
          <Popover content={<List bordered={false} className="listGrouptags">
                {Array.isArray(tagCategoryList) && tagCategoryList.map(tagCategory => <TagsGroupList key={tagCategory.id} data={tagCategory} />)}
              </List>} placement="bottomRight">
            <FontAwesomeIcon icon={faInfoCircle} />
          </Popover>
        </div>
        <S.TagRow>
          {projectDetail?.tags?.length > 0 ? formatTagList(projectDetail.tags).map((tag, index) => {
          return <Form.Item className="tag-item" key={index}>
                  <Tag color={TAG_COLORS[Number(tag.color)]} key={tag.key}>
                    {tag.label}
                  </Tag>
                </Form.Item>;
        }) : <div>No tags added</div>}
        </S.TagRow>
        <Row>
          <Col md={12}>
            <S.Label>Requested Completion Date</S.Label>
            <div>
              {requestedCompletionDate.isValid() ? moment(requestedCompletionDate, DEFAULT_DATE_PICKER_TIME_FORMAT).format(DEFAULT_TIME_FORMAT) : '-'}
            </div>
          </Col>
        </Row>
        <PricingDetail projectDetail={projectDetail} showAdjustmentModal={() => setIsAdjustmentModalVisible(true)} />
        <div>
          <S.Label>Status</S.Label>
          <ProjectSteps step={parseInt(projectDetail.status)} typebatch={projectDetail.source} />
        </div>
        <div style={{
        display: 'flex'
      }}>
          <PartnerState project={projectDetail} />
          <ClientState project={projectDetail} />
        </div>

        <EditProjectDetailsModal hideModal={() => setIsEditModalVisible(false)} isVisible={isEditModalVisible} showModal={() => setIsEditModalVisible(true)} />

        <AccountingModal projectId={projectDetail.id} hideModal={() => setIsAccountingModalVisible(false)} isVisible={isAccountingModalVisible} />

        <AdjustmentModal project={projectDetail} hideModal={() => setIsAdjustmentModalVisible(false)} isVisible={isAdjustmentModalVisible} />

        <ActionButtons changeProjectStatus={changeProjectStatus} changeStatusToActivated={changeStatusToActivated} confirm={confirm} createSubProject={createSubProject} sendMessengerTo={sendMessengerTo} showAccountingModal={() => setIsAccountingModalVisible(true)} showEditProjectModal={() => setIsEditModalVisible(true)} />
      </S.TagAndActionBtn>
    </S.LeftPanel>;
};
export default ProjectDetailContent;